import {
  Button as ArborButton,
  type ButtonProps as ArborButtonProps,
} from '@linktr.ee/arbor/components/Button';
import { cn } from '@linktr.ee/arbor/utils/cn';
import type { ReactNode } from 'react';

export type ButtonProps = Omit<
  ArborButtonProps,
  'children' | 'icon' | 'iconComponent' | 'iconProps'
> & {
  label?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  iconOnly?: boolean;
  newDesign?: boolean;
  fullWidth?: boolean;
};

const Button = ({
  label,
  children,
  icon,
  iconOnly = false,
  newDesign = false,
  fullWidth = true,
  variant = 'outline',
  shape = 'capsule',
  size = 'xl',
  className,
  ...props
}: ButtonProps) => {
  const content = children ?? label;

  return (
    <ArborButton
      {...props}
      variant={variant}
      shape={shape}
      size={size}
      className={cn(
        fullWidth && 'w-full',
        newDesign && iconOnly && 'gap-0',
        newDesign && fullWidth && icon && !iconOnly && 'relative',
        className
      )}
    >
      {icon ? (
        <>
          <span
            className={cn(
              'flex shrink-0 items-center [&>svg]:size-5',
              newDesign && '[&>svg]:size-6 [&>img]:size-6',
              newDesign && iconOnly && 'size-8 [&>svg]:!size-8 [&>img]:!size-8',
              newDesign &&
                fullWidth &&
                !iconOnly &&
                'absolute start-3 top-1/2 -translate-y-1/2 size-8 [&>svg]:!size-8 [&>img]:!size-8'
            )}
          >
            {icon}
          </span>
          <span
            className={cn(
              newDesign && fullWidth && !iconOnly && 'mx-auto',
              newDesign &&
                !fullWidth &&
                icon &&
                !iconOnly &&
                'min-w-0 max-w-full flex-1'
            )}
          >
            {content}
          </span>
        </>
      ) : (
        content
      )}
    </ArborButton>
  );
};

export default Button;
